@if (pageInfo.pageBar) {
  <header
    class="admin-page-bar"
    [class.admin-page-bar--subpage]="showBack()"
    aria-label="Encabezado de página"
  >
    <div class="admin-page-bar__main">
      @if (showBack()) {
        <button
          type="button"
          class="admin-page-bar__back"
          (click)="goBack()"
          [attr.aria-label]="backAriaLabel()"
        >
          <i-tabler name="chevron-left" class="admin-page-bar__back-icon flex" aria-hidden="true"></i-tabler>
        </button>
      }

      <div class="admin-page-bar__titles">
        <h1 class="admin-page-bar__title">{{ titleText() }}</h1>

        @if (subtitleText(); as subtitle) {
          <p class="admin-page-bar__subtitle">{{ subtitle }}</p>
        }
      </div>

      @if (showEndCluster()) {
        <div class="admin-page-bar__end">
          @if (leadingExtra(); as leadingTpl) {
            <div class="admin-page-bar__leading-extra">
              <ng-container *ngTemplateOutlet="leadingTpl" />
            </div>
          }

          @if (visibleActions().length) {
            <div class="admin-page-bar__actions admin-page-bar__actions--desktop">
              @for (action of desktopBarActions(); track action.id) {
                @if (action.menuItems?.length) {
                  <button
                    type="button"
                    [class]="actionButtonClass(action)"
                    [disabled]="action.disabled"
                    [matMenuTriggerFor]="actionSplitMenu"
                  >
                    @if (action.icon) {
                      @if (isIconifyActionIcon(action.icon)) {
                        <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                      } @else {
                        <mat-icon>{{ action.icon }}</mat-icon>
                      }
                    }
                    {{ actionLabel(action) }}
                    <mat-icon class="admin-page-bar__split-chevron">arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #actionSplitMenu="matMenu" xPosition="before">
                    @for (item of action.menuItems; track item.id) {
                      <button
                        type="button"
                        mat-menu-item
                        [disabled]="item.disabled"
                        (click)="runAction(item)"
                      >
                        @if (item.icon) {
                          @if (isIconifyActionIcon(item.icon)) {
                            <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="item.icon" aria-hidden="true"></span>
                          } @else {
                            <mat-icon>{{ item.icon }}</mat-icon>
                          }
                        }
                        <span>{{ actionLabel(item) }}</span>
                      </button>
                    }
                  </mat-menu>
                } @else {
                  <button
                    type="button"
                    [class]="actionButtonClass(action)"
                    [disabled]="action.disabled"
                    (click)="runAction(action)"
                  >
                    @if (action.icon) {
                      @if (isIconifyActionIcon(action.icon)) {
                        <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                      } @else {
                        <mat-icon>{{ action.icon }}</mat-icon>
                      }
                    }
                    {{ actionLabel(action) }}
                  </button>
                }
              }
              @if (desktopMenuActions().length) {
                <button
                  type="button"
                  class="milinco-btn-icon"
                  [matMenuTriggerFor]="pageBarDesktopMenu"
                  [attr.aria-label]="'catalog.myPage.actions' | translate"
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #pageBarDesktopMenu="matMenu" xPosition="before">
                  @for (action of desktopMenuActions(); track action.id) {
                    <button
                      type="button"
                      mat-menu-item
                      [disabled]="action.disabled"
                      (click)="runAction(action)"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      <span>{{ actionLabel(action) }}</span>
                    </button>
                  }
                </mat-menu>
              }
            </div>

            <div class="admin-page-bar__actions admin-page-bar__actions--mobile">
              @if (mobilePrimaryAction(); as primary) {
                @if (primary.menuItems?.length) {
                  <button
                    type="button"
                    [class]="actionButtonClass(primary)"
                    [disabled]="primary.disabled"
                    [matMenuTriggerFor]="mobilePrimarySplitMenu"
                  >
                    @if (primary.icon) {
                      @if (isIconifyActionIcon(primary.icon)) {
                        <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="primary.icon" aria-hidden="true"></span>
                      } @else {
                        <mat-icon>{{ primary.icon }}</mat-icon>
                      }
                    }
                    {{ actionLabel(primary) }}
                    <mat-icon class="admin-page-bar__split-chevron">arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #mobilePrimarySplitMenu="matMenu" xPosition="before">
                    @for (item of primary.menuItems; track item.id) {
                      <button
                        type="button"
                        mat-menu-item
                        [disabled]="item.disabled"
                        (click)="runAction(item)"
                      >
                        @if (item.icon) {
                          @if (isIconifyActionIcon(item.icon)) {
                            <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="item.icon" aria-hidden="true"></span>
                          } @else {
                            <mat-icon>{{ item.icon }}</mat-icon>
                          }
                        }
                        <span>{{ actionLabel(item) }}</span>
                      </button>
                    }
                  </mat-menu>
                } @else {
                  <button
                    type="button"
                    [class]="actionButtonClass(primary)"
                    [disabled]="primary.disabled"
                    (click)="runAction(primary)"
                  >
                    @if (primary.icon) {
                      @if (isIconifyActionIcon(primary.icon)) {
                        <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="primary.icon" aria-hidden="true"></span>
                      } @else {
                        <mat-icon>{{ primary.icon }}</mat-icon>
                      }
                    }
                    {{ actionLabel(primary) }}
                  </button>
                }
              }
              @if (mobileMenuActions().length) {
                <button
                  type="button"
                  class="milinco-btn-icon"
                  [matMenuTriggerFor]="pageBarActionsMenu"
                  [attr.aria-label]="'catalog.myPage.actions' | translate"
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #pageBarActionsMenu="matMenu" xPosition="before">
                  @for (action of mobileMenuActions(); track action.id) {
                    <button
                      type="button"
                      mat-menu-item
                      [disabled]="action.disabled"
                      (click)="runAction(action)"
                    >
                      @if (action.icon) {
                        @if (isIconifyActionIcon(action.icon)) {
                          <span class="iconify admin-page-bar__action-icon" [attr.data-icon]="action.icon" aria-hidden="true"></span>
                        } @else {
                          <mat-icon>{{ action.icon }}</mat-icon>
                        }
                      }
                      <span>{{ actionLabel(action) }}</span>
                    </button>
                  }
                </mat-menu>
              }
            </div>
          }
        </div>
      }
    </div>
  </header>
}
